import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Error = styled.strong`
  color: ${({ theme }) => theme.themeColors.orange2};
  font-size: ${({ theme }) => theme.fontSize(0)};
  font-weight: 400;
`;

const FieldErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.375rem;
`;

function FieldError({ errors, show, ...props }) {
  if (!show) {
    return null;
  }

  return (
    <FieldErrorWrapper className="field-error-wrapper" {...props}>
      {errors?.map((errorMsg) => (
        <Error key={`error-${errorMsg}`} className="field-error">
          {errorMsg}
        </Error>
      ))}
    </FieldErrorWrapper>
  );
}

FieldError.propTypes = {
  show: PropTypes.bool,
  errors: PropTypes.oneOfType(
    [PropTypes.arrayOf(PropTypes.string)],
    PropTypes.string
  ),
};

FieldError.defaultProps = {
  show: false,
  errors: [],
};

export default FieldError;
